// src/pages/admin/AbandonedCartsPage.jsx
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { ShoppingCart } from 'lucide-react'
import { adminAbandonedCartsApi } from '../../api/services'
import { Card, CardBody, Button, StatusBadge, PageSpinner } from '../../components/common/ui'
import toast from 'react-hot-toast'

export default function AbandonedCartsPage() {
  const qc = useQueryClient()
  const { data, isLoading } = useQuery({ queryKey: ['admin-abandoned-carts'], queryFn: () => adminAbandonedCartsApi.index() })
  const process = useMutation({ mutationFn: () => adminAbandonedCartsApi.processDue(), onSuccess: res => { toast.success(`Queued ${res?.data?.data?.sent??0} emails`); qc.invalidateQueries(['admin-abandoned-carts']) } })

  if (isLoading) return <PageSpinner />
  const { records={}, stats={} } = data?.data?.data || {}
  const list = records.data || []

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-display font-bold flex items-center gap-2"><ShoppingCart size={20} className="text-pink" /> Abandoned Carts</h1>
        <Button size="sm" variant="secondary" loading={process.isPending} onClick={() => process.mutate()}>Send Recovery Emails</Button>
      </div>
      <div className="grid grid-cols-3 gap-4 mb-6">
        {[['Total Abandoned',stats.total??0],['Recovered',stats.recovered??0],['Recovery Rate',stats.recovery_rate?`${stats.recovery_rate}%`:'—']].map(([l,v])=>(
          <div key={l} className="bg-white border border-border rounded-xl p-4 text-center">
            <p className="text-xl font-bold text-gray-900">{v}</p>
            <p className="text-xs text-muted">{l}</p>
          </div>
        ))}
      </div>
      <div className="space-y-2">
        {list.map(r => (
          <Card key={r.id}>
            <CardBody className="flex items-center justify-between text-sm">
              <div>
                <p className="font-bold">{r.user?.name||r.email}</p>
                <p className="text-xs text-muted">Cart value: ₹{Number(r.cart_value||0).toLocaleString('en-IN')} · {new Date(r.created_at).toLocaleDateString('en-IN')}</p>
              </div>
              <StatusBadge status={r.status||'sent'} />
            </CardBody>
          </Card>
        ))}
        {list.length===0 && <p className="text-center text-muted py-8">No records.</p>}
      </div>
    </div>
  )
}
